export default ['visible', 'position', 'scale', 'rotation'];



// WEBPACK FOOTER //
// ./src/components/components/DefaultComponents.js